<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("form") }} {{ $tc("role", 2) }}
      </div>
    </div>

    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              Role Name
              <input
                v-model="form.role_name"
                :disabled="role_id == 1 ? true : false"
              />
            </div>
          </div>
        </div>
        <!-- <div
          class="d-flex align-items-center min-height-50"
          v-if="role_id != 1"
        >
          <label class="mb-0 mr-3">{{ $t(`active`) }}</label>
          <b-form-checkbox
            switch
            :checked="form.role_is_active == 'Y'"
            @input="
              (e) => {
                form.role_is_active = e ? 'Y' : 'N';
              }
            "
          />
        </div> -->
        <div class="d-flex align-items-center" v-if="role_id != 1">
          <b-form-checkbox
            class="j-checkbox mb-0 ml-2"
            :checked="form.role_is_active === 'Y'"
            @input="
              (e) => {
                form.role_is_active = e ? 'Y' : 'N';
              }
            "
          />
          <label class="mb-0 mr-3">{{ $t(`active`) }}</label>
        </div>

        <br />
        <!-- <div
          class="d-flex align-items-center min-height-50"
          v-if="role_id != 1"
        >
          <label class="mb-0 mr-3">{{ $t(`iscinemalevel`) }}</label>
          <b-form-checkbox
            switch
            :checked="form.role_is_cinema_level == 'Y'"
            @input="
              (e) => {
                form.role_is_cinema_level = e ? 'Y' : 'N';
              }
            "
          />
        </div> -->
        <div class="d-flex align-items-center" v-if="role_id != 1">
          <b-form-checkbox
            class="j-checkbox mb-0 ml-2"
            :checked="form.role_is_cinema_level === 'Y'"
            @input="
              (e) => {
                form.role_is_cinema_level = e ? 'Y' : 'N';
              }
            "
          />
          <label class="mb-0 mr-3">{{ $t(`iscinemalevel`) }}</label>
        </div>

        <div
          class="d-flex align-items-center min-height-50"
          v-if="acceptRoles.includes($route.query.id)"
        >
          <b-form-checkbox
            class="j-checkbox mb-0 ml-2"
            v-model="superAccess"
            @input="giveAllAccess($event)"
          />
          <label class="mb-0 mr-3">Give access to all modules</label>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="saveRole" class="btn-blue">
            {{ $t("save") }}
          </button>
          <b-button
            class="btn-outline-grey"
            @click="
              $router.push({
                path: '/user-management/roles-list',
              })
            "
            variant="default"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>

    <div class="white-wrapper">
      <div class="col-md-5 pl-0 mb-4">
        <b-form-input
          v-model="searchValue"
          placeholder="Search for Module...."
          @input="onSearch"
        ></b-form-input>
      </div>
      <div
        v-if="modules.length == 0"
        class="text-center my-5 py-5 section-border"
      >
        <h3 class="mb-0">No Modules Found</h3>
      </div>
      <div
        v-for="modCat in modules"
        :key="modCat.module_category_id + '_modCat'"
        class="mt-3"
      >
        <div
          class="section-title section-border role-title d-flex justify-content-between align-items-center"
          v-b-toggle="`collapse-${modCat.module_category_id}`"
        >
          <div class="mb-0">{{ modCat.module_category_name }}</div>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse :id="`collapse-${modCat.module_category_id}`">
          <table class="list-view-table mt-2 mb-1">
            <thead>
              <tr>
                <th>Module</th>
                <th>
                  <b-form-checkbox
                    v-if="searchValue.length == 0"
                    class="j-checkbox ml-1"
                    v-model="modCat.cat_read"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      selectAllCat(modCat.module_category_id, 'read', $event)
                    "
                    >Read</b-form-checkbox
                  >
                  <p v-else>Read</p>
                </th>
                <th>
                  <b-form-checkbox
                    v-if="searchValue.length == 0"
                    class="j-checkbox ml-1"
                    v-model="modCat.cat_create"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      selectAllCat(modCat.module_category_id, 'create', $event)
                    "
                    >Create</b-form-checkbox
                  >
                  <p v-else>Create</p>
                </th>
                <th>
                  <b-form-checkbox
                    v-if="searchValue.length == 0"
                    class="j-checkbox ml-1"
                    v-model="modCat.cat_update"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      selectAllCat(modCat.module_category_id, 'update', $event)
                    "
                    >Update</b-form-checkbox
                  >
                  <p v-else>Update</p>
                </th>
                <th>
                  <b-form-checkbox
                    v-if="searchValue.length == 0"
                    class="j-checkbox ml-1"
                    v-model="modCat.cat_delete"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      selectAllCat(modCat.module_category_id, 'delete', $event)
                    "
                    >Delete</b-form-checkbox
                  >
                  <p v-else>Delete</p>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(mod, modIndex) in modCat.modules"
                :key="modIndex + 'modIndex'"
              >
                <td>{{ mod.module_name }}</td>
                <td>
                  <b-form-checkbox
                    class="j-checkbox"
                    v-model="mod.read"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      onSelect(
                        modCat.module_category_id,
                        mod.module_id,
                        'read',
                        $event
                      )
                    "
                    >&nbsp;</b-form-checkbox
                  >
                </td>
                <td>
                  <b-form-checkbox
                    class="j-checkbox"
                    v-model="mod.create"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      onSelect(
                        modCat.module_category_id,
                        mod.module_id,
                        'create',
                        $event
                      )
                    "
                    >&nbsp;</b-form-checkbox
                  >
                </td>
                <td>
                  <b-form-checkbox
                    class="j-checkbox"
                    v-model="mod.update"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      onSelect(
                        modCat.module_category_id,
                        mod.module_id,
                        'update',
                        $event
                      )
                    "
                    >&nbsp;</b-form-checkbox
                  >
                </td>
                <td>
                  <b-form-checkbox
                    class="j-checkbox"
                    v-model="mod.delete"
                    value="Y"
                    unchecked-value="N"
                    @input="
                      onSelect(
                        modCat.module_category_id,
                        mod.module_id,
                        'delete',
                        $event
                      )
                    "
                    >&nbsp;</b-form-checkbox
                  >
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import UserManagmentServices from "@/services/UserManagmentServices.js";
import UserService from "@/services/UserService";

export default {
  components: {},
  data() {
    return {
      searchValue: "",

      form: {
        role_id: "",
        role_name: "",
        role_is_active: "Y",
        role_is_cinema_level: "Y",
      },
      modules: [],
      superAccess: false,

      allModules: [],
      acceptRoles: ["2", "3", "41"],
    };
  },
  methods: {
    updateUserModules(mod, accessType, event) {
      let mod_ids = [];
      let deSelected_mod_ids = [];
      if (event === "N") {
        deSelected_mod_ids = [mod];
      } else {
        mod_ids = [mod];
      }

      let payload = {
        role_id: this.role_id,
        module_id: mod_ids,
        del_module_id: deSelected_mod_ids,
        access_id: accessType,
      };

      UserService.AddPermission(payload)
        .then((response) => {
          const { data } = response;
          // if (data.status) {
          //   // this.$toasted.show("User Permission updated successfully");
          // } else {
          //   this.$toasted.show(data.message);
          // }
        })
        .catch(this._CatchError);
    },
    addAllModules(mod_id, action) {
      console.log(mod_id, "from all modules");
      let payload = {
        role_id: this.role_id,
        module_id: action == "Y" ? mod_id : [],
        del_module_id: action == "N" ? mod_id : [],
        access_id: 1,
      };

      UserService.AddPermission(payload).then((res) => {
        // this.$toasted.show("Role Permission updated successfully");
      });
    },
    giveAllAccess(e) {
      if (
        this.acceptRoles.includes(this.$route.query.id) &&
        this.modules.length
      ) {
        if (e) {
          this.modules.forEach((module) => {
            module["cat_create"] = "Y";
            module["cat_read"] = "Y";
            module["cat_update"] = "Y";
            module["cat_delete"] = "N";
          });
        } else {
          this.modules.forEach((module) => {
            module["cat_create"] = "N";
            module["cat_read"] = "N";
            module["cat_update"] = "N";
            module["cat_delete"] = "N";
          });
        }
      }
    },
    async saveRole() {
      try {
        let loader = this.$loading.show();

        const response = await UserManagmentServices.saveRole({
          ...this.form,
          modules: this.allModules,
        });
        loader.hide();
        this.$toasted.show(response.data.message);
        this.$router.go(-1);
      } catch (error) {
        console.log("Error in saving role ", error);
        loader.hide();
      }
    },
    async getSingleRole() {
      try {
        const response = await UserManagmentServices.getSingleRole({
          role_id: this.role_id,
        });

        this.form = {
          ...this.form,
          ...response.data.data,
        };
      } catch (error) {
        console.log("Error in getSingleRole ", error);
      }
    },
    async getModules() {
      try {
        const response = await UserManagmentServices.getModules({
          role_id: this.role_id,
        });
        this.modules = response.data.data;
        this.allModules = response.data.data;
      } catch (error) {
        console.log("Error in getting modules ", error);
      }
    },
    onSearch(val) {
      if (!val) {
        this.modules = this.allModules;
        return;
      }

      this.modules = [];

      for (const modCat of this.allModules) {
        const filteredModules = [];

        let displayCat = false;
        for (const mod of modCat.modules) {
          let display;
          if (
            mod.module_name &&
            mod.module_name.toLowerCase().startsWith(val.toLowerCase())
          ) {
            filteredModules.push(mod);
          }
        }

        if (!filteredModules.length) continue;

        this.modules.push({
          ...modCat,
          modules: filteredModules,
        });
      }
    },
    selectAllCat(cat_id, action, val) {
      for (const modCat of this.allModules) {
        if (modCat.module_category_id == cat_id) {
          for (const mod of modCat.modules) {
            mod[action] = val;
          }
        }
      }
      for (const modCat of this.modules) {
        if (modCat.module_category_id == cat_id) {
          for (const mod of modCat.modules) {
            mod[action] = val;
          }
        }
      }
    },
    onSelect(cat_id, mod_id, action, val) {
      if (val === "N" && this.role_id == 1) {
        this.$toasted.show("Can only add superadmin access, cannot remove");
        return;
      }
      if (action == "read") {
        this.updateUserModules(mod_id, 1, val);
      }
      for (const modCat of this.allModules) {
        if (modCat.module_category_id == cat_id) {
          for (const mod of modCat.modules) {
            if (mod.module_id == mod_id) {
              mod[action] = val;
            }
          }
        }
      }
    },
  },
  beforeMount() {
    const { id } = this.$route.query;

    if (id && !isNaN(id)) {
      this.role_id = id;
      this.getSingleRole();
    }
    this.getModules();
  },
};
</script>
<style>
.role-title {
  cursor: pointer;
  font-size: 18px !important;
  padding: 12px !important;
}
.th-text {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/Roles/RoleForm.vue